<template>
  <span
    ref="container"
    class="lottie-icon-wrap"
    :style="wrapStyle"
  ></span>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import lottie from "lottie-web";

const props = defineProps({
  animationData: {
    type: Object,
    required: true,
  },
  size: {
    type: Number,
    default: 18,
  },
});

const container = ref(null);
let anim = null;

const wrapStyle = computed(() => ({
  width: props.size + "px",
  height: props.size + "px",
}));

onMounted(() => {
  anim = lottie.loadAnimation({
    container: container.value,
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: props.animationData,
  });
});

onBeforeUnmount(() => {
  if (anim) {
    anim.destroy();
    anim = null;
  }
});
</script>

<style scoped>
.lottie-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
</style>
